export const SET_MOVIE_LIST = 'SET_MOVIE_LIST';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const SET_LOADING = 'SET_LOADING';
export const LOAD_MORE_MOVIE_RESULTS = 'LOAD_MORE_MOVIE_RESULTS';
export const SET_MOVIE_CATEGORY = 'SET_MOVIE_CATEGORY';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_CURRENT_MOVIE_DETAILS = 'SET_CURRENT_MOVIE_DETAILS';
export const CLEAR_CURRENT_MOVIE_DETAILS = 'CLEAR_CURRENT_MOVIE_DETAILS';
export const SET_CURRENT_MOVIE_CREDITS = 'SET_CURRENT_MOVIE_CREDITS';
export const SET_CURRENT_MOVIE_REVIEWS = 'SET_CURRENT_MOVIE_REVIEWS';
export const SET_CURRENT_MOVIE_IMAGES = 'SET_CURRENT_MOVIE_IMAGES';
export const SET_CURRENT_MOVIE_VIDEOS = 'SET_CURRENT_MOVIE_VIDEOS';
export const SET_MATCH_PATH = 'SET_MATCH_PATH';
